module.exports = __webpack_public_path__ + "static/media/citizen-logo-2025-orange.4c443862.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/citizen-logo-2025-orange.svg
// module id = 923
// module chunks = 0